export default "__VITE_ASSET__3131e949__"